import React from 'react';
import { Calendar, Download } from 'lucide-react';
const HERO_BG = 'https://drwzpk38qkpfb.cloudfront.net/www.apc360zone.com/preview/uploaded/images/Redesigne%202024/Schedule_bg.jpeg?opt=w3';
export function HeroSection() {
  return <section className="relative py-24 md:py-32 flex items-center border-b border-brand-gray-800 overflow-hidden" data-id="element-891">
      <img src={HERO_BG} alt="Training Calendar" className="block absolute inset-0 w-full h-full object-cover" onError={e => {
      e.currentTarget.src = 'https://cdn.magicpatterns.com/uploads/6VNDFTEeWuRsoQPUmRUT27/law1.jpg';
    }} data-id="element-892" />
      <div className="absolute inset-0 bg-gradient-to-b from-brand-black/50 via-brand-black/40 to-brand-black z-[1]" data-id="element-893" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full text-center" data-id="element-894">
        <div className="inline-flex items-center gap-2 px-3 py-1 border border-brand-teal/30 bg-brand-teal/10 text-brand-teal text-xs font-bold uppercase tracking-widest mb-6" data-id="element-895">
          <Calendar className="w-4 h-4" data-id="element-896" />
          Schedule
        </div>
        <h1 className="text-4xl md:text-6xl font-extrabold text-brand-white tracking-tight leading-tight mb-8 uppercase" data-id="element-897">
          2026 Training Calendar
        </h1>

        <a href="https://www.apc360zone.com/uploaded/files/COURSE+REGISTRATION+FORM+2024.pdf?direct=1" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 px-6 py-3 bg-brand-teal/20 border border-brand-teal text-brand-white font-bold uppercase tracking-wider hover:bg-brand-teal transition-colors" data-id="element-898">
          <Download className="w-5 h-5" data-id="element-899" />
          Download Course Registration Form
        </a>
      </div>
    </section>;
}